import { Navbar } from "./navbar";
import faqElement from "../assets/images/faqElement.png"
import { useEffect } from "react";
export function Faq() {

    useEffect(()=>{
        window.scrollTo(0, 0);
    },[])
    return(
        <div className="faqPage">
            <div className="container">
                <Navbar />
            </div>
           
            <section className="faqSec">
                <div className="faqElement">
                    <img className="img-fluid" src={faqElement} alt="faq" />
                </div>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <h1 className="heading56 mb-4">Frequently Asked <span>Questions</span></h1>
                          
                        </div>
                        <div className="col-lg-8">
                           <div className="faqSec">
                           <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                                <div className="panel panel-default  faq-ques animatable fadeInUp">
                                    <div className="panel-heading" role="tab" id="headingOne">
                                    <h4 className="panel-title ">
                                        <a className="collapsed" data-bs-toggle="collapse" data-bs-parent="#accordion" href="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                        What can we expect from Corolla Roofing once we call with a leaking roof?
                                        </a>
                                    </h4>
                                    </div>
                                    <div id="collapseOne" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingOne">
                                        <div className="panel-body">
                                        A trained roofing technician will investigate the roof, determine the source of the roof leak and repair a small leak. If it is determined that the leak is larger in nature, Corolla Roofing will provide a written proposal that will include a diagram and/or photo showing the location and cause of the leak and not to exceed the cost to repair. We have experts on call for repair service 7 days a week that can usually address your needs within a 24-hour period.                                         </div>
                                    </div>
                                </div>
                                <div className="panel panel-default  faq-ques animatable fadeInUp">
                                    <div className="panel-heading" role="tab" id="headingThree">
                                    <h4 className="panel-title">
                                        <a className="collapsed" data-bs-toggle="collapse" data-bs-parent="#accordion" href="#collapsefive" aria-expanded="false" aria-controls="collapseThree">
                                        We have used some unreliable roofers in the past. So how do we know you will provide a quality service?
                                        </a>
                                    </h4>
                                    </div>
                                    <div id="collapsefive" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                                    {/* <div className="panel-body">Blockpix is for everyone, Who wants own virtual land with very small investment, build the land and earn passive income from it.  </div> */}
                                        <div className="panel-body">
                                        Quality reviews and client referrals are the best way to grow our business. The better we deliver on customer service and roofing services, the more our reputation grows. This means we place a heavy emphasis on our technicians to get the job done right the first time. Every project has the personal touch of our company president, who has more than 30 years in the roofing industry.                                         
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="panel panel-default  faq-ques animatable fadeInUp">
                                    <div className="panel-heading" role="tab" id="headingThree">
                                    <h4 className="panel-title">
                                        <a className="collapsed" data-bs-toggle="collapse" data-bs-parent="#accordion" href="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                        How will you deal with the fact that our facility has many different types of roofs? 
                                        </a>
                                    </h4>
                                    </div>
                                    <div id="collapseSix" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingThree">
                                        <div className="panel-body">
                                        Corolla Roofing Inc. is licensed and approved by all major manufacturers. Our crews are certified and equipped to make repairs to all major manufacturer's roofing systems during a leak investigation. This means that Corolla Roofing can repair a roof installed by another roofing contractor without voiding the warranty.                                        
                                        </div>
                                    </div>
                                </div>
                                <div className="panel panel-default  faq-ques animatable fadeInUp">
                                    <div className="panel-heading" role="tab" id="headingTwo">
                                    <h4 className="panel-title ">
                                        <a className="collapsed" data-bs-toggle="collapse" data-bs-parent="#accordion" href="#collapsefour" aria-expanded="false" aria-controls="collapseTwo">
                                        Does Corolla Roofing have a proven track record of customer satisfaction?
                                        </a>
                                    </h4>
                                    </div>
                                    <div id="collapsefour" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingTwo">
                                    <div className="panel-body">
                                        Yes! We rely on our reputation to build our ever-growing client list and offer examples of our previous work through our projects page that includes such roofing services to companies like:
                                        <ul className="mt-3">
                                            <li>Massport (Logan Airport)</li>
                                            <li>Northeastern University</li>
                                            <li>Beth Israel Deaconess Medical Center</li>
                                            <li>New England Baptist Hospital</li>
                                            <li>Massachusetts Maritime Academy</li>
                                            <li>Chelsea Clock Company</li>
                                        </ul>
                                    </div>
                                    </div>
                                </div>
                                <div className="panel panel-default  faq-ques animatable fadeInUp">
                                    <div className="panel-heading" role="tab" id="headingOne">
                                    <h4 className="panel-title ">
                                        <a className="collapsed" data-bs-toggle="collapse" data-bs-parent="#accordion" href="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        How can I be sure that Corolla’s employees are adequately insured?
                                        </a>
                                    </h4>
                                    </div>
                                    <div id="collapseTwo" className="panel-collapse collapse" role="tabpanel" aria-labelledby="headingOne">
                                    <div className="panel-body">
                                    We can provide you with a certificate of insurance via email, fax, or US mail prior to the commencement of any repair work. This means that you will be fully protected should there be any damage to your property or injury to our workers. We pride ourselves on offering our valuable New England clients the peace of mind needed and expected, including presenting insurance.                                     
                                    </div>
                                    </div>
                                </div>
                           
                            </div>
                           </div>
                        </div>
                    </div>
                </div>
            </section>
         


        </div>
    )
}


